
import { Form,Link,  useLoaderData, useNavigate } from "react-router-dom";
import { Select } from "../components/Select";
import { Button } from "../components/Button";
import { TextField } from "../components/TextField";
import { useEffect, useState } from "react";
import { _getTicketStatusOptions, addTicketPayment, deleteOrderTicket, updateOrderTicketStatus } from "../services/api";
import { formatDate, getUserId, getUserPermission } from "../services/helpers";
import mixpanel from "../services/mixpanel";

export function OrderDetails(){
	const loaderData  = useLoaderData();
	const orderTicket = loaderData.details;
	console.log(orderTicket.order_ticket_items);
	const serviceItemsList = orderTicket.order_ticket_items;
	const customerDetails = loaderData.customer_details.customer_details;
	const [showDialog, setShowDialog] = useState(false);
	const [showPaymentDialog, setShowPaymentDialog] = useState(false);
	const [showDeleteDialog, setShowDeleteDialog] = useState(false);
	const [currentStatus,setCurrentStatus] = useState(orderTicket.order_ticket_details.status);
	// const [currentStatus,setCurrentStatus] = useState(serviceItemsList[0]?.status ?? "open");
	const [_statusOptions,_setStatusOptions] = useState(["open"]);
	const [canInvoice,setCanInvoice] = useState(true);
	const navigate = useNavigate();

	useEffect(()=> {
		mixpanel.identify(getUserId());
		serviceItemsList.map((service)=>service.price == null && setCanInvoice(false));
		try{
			_getTicketStatusOptions().then((statuses)=>{
				const map = statuses.statuses.map((stat)=>stat.status);
				_setStatusOptions(map);
			});
		} catch(e){

		}
	},[]);

	function submitTicketPayment(e) {
			e.preventDefault();
			const form = document.getElementById("addTicketPaymentForm");
			const formData = new FormData(form);
			const ticketId = window.location.pathname.split('/').pop();

			const payload = {
				ticket_id: ticketId,
				currency: formData.get("currency"),
				amount: formData.get("amount"),
				payment_method: formData.get("payment_method"),
				payment_date: formData.get("payment_date"),
				reference: formData.get("reference"),
				ticket_type: "order"
			};


			addTicketPayment(payload).then(async(result)=>{
				let message = await result.json();
				alert(message.msg);
				setShowPaymentDialog(false);
			});

			// console.log(JSON.stringify(payload));
			// setShowPaymentDialog(false);
		}

		function deleteTicket(){
			deleteOrderTicket(window.location.pathname.split('/').pop()).then(
				(result)=>{
					alert(result.msg);
					navigate(`/dashboard/members/u/${customerDetails.customer_id}/vehicles`);
					setShowDialog(false);
				}
			)
		}

	// function ope
	function showEditPopup(){
		setShowDialog(true);
	}

	function hideEditPopup(){
		setShowDialog(false);
	}

	function updateStatus(){
		hideEditPopup();

		const form = document.getElementById("changeStatusForm");
		const formData = new FormData(form);
		const ticketId = window.location.pathname.split('/').pop();
		const payload = {
			"order_id" : ticketId,
			"new_status" : formData.get("status")
		};

		updateOrderTicketStatus(payload)
		.then(async(response)=>{
			const result = await response.json();
			console.log("response",result,result.new_status);
			setCurrentStatus(result.new_status);
		}).catch((e)=>{
			console.log('something broke with updateServiceTicketStatus',e);
		});

	}




// const totalPrice = serviceItemsList.reduce((sum, item) => {
// 		if (item.price && !isNaN(Number(item.price))) {
// 			return sum + (Number(item.price)*Number(item.units));
// 		}
// 		return sum;
// 	}, 0);

	return (
		<main id="AddVehicleService">
			<h1>Order Ticket Details</h1>
			<Link to={`/dashboard/members/u/${customerDetails.customer_id}/services`}>{`${customerDetails.first_name} ${customerDetails.last_name}`}'s Services</Link>

			<div id="page-detail-card">
				<div id="header-section">
					<div id="middle">
						<p>Status: <span className="capitalize">{currentStatus}</span>
						<a><small class="blue-text action-text" onClick={showEditPopup}>Edit</small></a>
						</p>
						<h3>{customerDetails.first_name} {customerDetails.last_name}</h3>
						<p>{customerDetails.phone_number}</p>
						{/* <h3>{vehicleData.license_plate}</h3>
						<p>{vehicleData.vehicle_name} ({vehicleData.vehicle_year})</p>
						<p>{vehicleData.customer_name}</p> */}
						<h4>GHS {orderTicket.order_ticket_details.total_invoice}</h4>
						{/* <Link >Invoice Customer//</Link> */}
					</div>
					<div id="end">
						<p>Date Created: {formatDate(orderTicket.order_ticket_details.date_created)}</p>
						<p>Date Updated: {formatDate(orderTicket.order_ticket_details.date_updated)}</p>
							<Link to={`/dashboard/services/add_ticket?ticket_type=order&ticket_id=${window.location.pathname.split('/').pop()}`}>Edit Order Ticket</Link>
							{/* <Link to={`/dashboard/members/u/${customerDetails.uuid}/add_order?order_id=${window.location.pathname.split('/').pop()}`}>Edit Order Ticket</Link> */}
							<button className="link" onClick={()=>setShowPaymentDialog(true)}>Record Payment</button>
							{getUserPermission() === "admin"  && <button className="link red-text"  onClick={()=>{setShowDeleteDialog(true)}}>Delete Service Ticket </button>}
							{canInvoice && <Link to={`/dashboard/services/invoice/${serviceItemsList[0]?.order_id}`}>Generate Invoice</Link>}
					</div>
				</div>
				<div id="service-ticket-items">
					<table className="invoice-table">
						<thead>
							<tr>
								<th>Service Item Name</th>
								<th>Quantity</th>
								<th>Unit price</th>
								<th>Sub Total</th>
							</tr>
						</thead>
						<tbody>
							{
								serviceItemsList.map((element)=>   (
									<tr key={element.item_id}>
										<td>
											{element.item_name}
											<p className="description">{element.description}</p>
										</td>
										<td>{element.units}</td>
										<td>{element.price == null ? "n/a":`${element.currency} ${element.price}`}</td>
										<td>{element.price == null ? "n/a":`${element.currency} ${Number(element.price)*Number(element.units)}`}</td>
									</tr>)
								)
							}


							<tr className="grey-text">
								<td></td>
								<td></td>
								<td>Sub total</td>
								<td>GHS {orderTicket.order_ticket_details.total_bill}</td>
							</tr>
							{orderTicket.order_ticket_details.discount_total !== 0 && <tr className="grey-text">
								<td></td>
								<td></td>
								<td>Discount Applied</td>
								<td>GHS {orderTicket.order_ticket_details.discount_total}</td>
							</tr>}
							<tr>
								<td></td>
								<td></td>
								<td>TOTAL</td>
								<td>GHS {orderTicket.order_ticket_details.total_invoice}</td>
							</tr>


						</tbody>
					</table>
				</div>
			</div>
			{showDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="changeStatusForm">
							<div className="dialog-header">
								<h3>Change Status</h3>
							</div>
							<div className="dialog-content">
								<div className="row">
									<div className="col-3">
										<Select
											label="Status"
											options={_statusOptions}
											name="status"
											defaultValue={currentStatus}
											// value={currencyField}
											// onChange={(e) => set(e.target.value)}
										/>

									</div>
								</div>
							</div>
							<div className="dialog-footer">
								<Button onClick={hideEditPopup} color="red" label="Cancel"/>
								<Button onClick={updateStatus} label="Update Status" color="green" />
							</div>
						</Form>
					</div>
				</div>
			)}

			{showDeleteDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="addServiceItemForm">
							<div className="dialog-header">
								<h3>Are You sure you want to delete the Order Ticket {window.location.pathname.split('/').pop()}</h3>
							</div>
							<div className="dialog-footer">
								<Button onClick={()=>setShowDeleteDialog(false)} label="Cancel" color="green" />
								<Button onClick={deleteTicket} color="red" label="Delete"/>
							</div>
						</Form>
					</div>
				</div>
			)}


						{showPaymentDialog && (
							<div className="dialog-overlay" onClick={()=>setShowPaymentDialog(false)}>

								<div className="dialog" onClick={(e)=>e.stopPropagation()}>
									<Form id="addTicketPaymentForm" onSubmit={submitTicketPayment}>
										<div className="dialog-header">
											<h3>Add Payment for Service</h3>
										</div>
										<div className="dialog-body">

											<div className="row-2">
												<Select
													label="Currency"
													name="currency"
													options={["GHS","USD"]}
												/>

												<TextField
													label="Amount"
													name="amount"
													type={"number"}
												/>
											</div>

											<div className="row-2">
												<Select
													label={"Payment method"}
													name="payment_method"
													options={["Cash","Paystack","Zipbooks"]}
												/>

												<TextField
													label="Payment Date"
													name="payment_date"
													type={"date"}
												/>

											</div>


											<TextField
												label="Reference"
												type={"text"}
												name="reference"
											/>
										</div>
										<div className="dialog-footer">
											<Button onClick={()=>setShowPaymentDialog(null)} color="red" label="Cancel"/>
											<Button type="submit" label="Record Payment" color="green" />
										</div>
									</Form>
								</div>
							</div>
						)}
		</main>
	);
}